// extracted by mini-css-extract-plugin
module.exports =  {"root":"iaoTII1LqR5XM6zr5ByW"};